import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <Link to="/">
            <div className="navigation-logo">
              <div className="navigation-logo-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <span className="navigation-brand section-title">SylliPlan</span>
            </div>
          </Link>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links">
              <li>
                <Link to="/syllabus-upload-planner">
                  <div className="navigation-link">
                    <span>Planner</span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/ai-study-helper">
                  <div className="navigation-link">
                    <span>AI Helper</span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/account-subscriptions">
                  <div className="navigation-link">
                    <span>Pricing</span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/login">
                  <div className="navigation-link">
                    <span>Login</span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/sign-up">
                  <div className="navigation-link">
                    <span>Sign Up</span>
                  </div>
                </Link>
              </li>
            </ul>
            <div className="navigation-actions">
              <button
                id="themeToggle"
                aria-label="Toggle theme"
                className="navigation-theme-btn"
              >
                <span className="navigation-icon-light">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="4"></circle>
                      <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
                    </g>
                  </svg>
                </span>
                <span className="navigation-icon-dark">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"
                    ></path>
                  </svg>
                </span>
              </button>
              <Link to="/account-subscriptions">
                <div className="btn btn-primary btn-sm">
                  <span>Get Started</span>
                </div>
              </Link>
            </div>
          </div>
          <button
            id="mobileMenuOpen"
            aria-label="Open menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <div className="navigation-logo">
            <div className="navigation-logo-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                  <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                  <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                  <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                  <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                  <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                </g>
              </svg>
            </div>
            <span className="navigation-brand section-title">SylliPlan</span>
          </div>
          <button
            id="mobileMenuClose"
            aria-label="Close menu"
            className="navigation-mobile-close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                <path d="M15 3v18M8 9l3 3l-3 3"></path>
              </g>
            </svg>
          </button>
        </div>
        <div className="navigation-mobile-content">
          <ul className="navigation-mobile-links">
            <li>
              <Link to="/syllabus-upload-planner">
                <div className="navigation-mobile-link">
                  <span>Semester Planner</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/ai-study-helper">
                <div className="navigation-mobile-link">
                  <span>AI Study Tools</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/account-subscriptions">
                <div className="navigation-mobile-link">
                  <span>Pricing &amp; Plans</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/account-subscriptions">
                <div className="navigation-mobile-link">
                  <span>My Account</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/login">
                <div className="navigation-mobile-link">
                  <span>Login</span>
                </div>
              </Link>
            </li>
            <div data-thq="thq-dropdown" className="navigation-thq-dropdown">
              <div
                data-thq="thq-dropdown-toggle"
                className="navigation-thq-dropdown-toggle"
              >
                <span>
                  {props.text ?? (
                    <Fragment>
                      <span className="navigation-text24">More</span>
                    </Fragment>
                  )}
                </span>
                <div
                  data-thq="thq-dropdown-arrow"
                  className="navigation-thq-dropdown-arrow"
                >
                  <svg viewBox="0 0 1024 1024" className="navigation-icon38">
                    <path d="M426 726v-428l214 214z"></path>
                  </svg>
                </div>
              </div>
              <ul
                data-thq="thq-dropdown-list"
                className="navigation-thq-dropdown-list"
              >
                <li>
                  <Link to="/sign-up">
                    <div className="navigation-mobile-link">
                      <span>Sign Up</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          </ul>
          <div className="navigation-mobile-footer">
            <Link to="/account-subscriptions">
              <div className="navigation-mobile-cta btn btn-primary btn-lg">
                <span>Join SylliPlan Now</span>
              </div>
            </Link>
            <div className="navigation-mobile-theme-row">
              <span className="section-content">Switch Theme</span>
              <button
                id="themeToggleMobile"
                aria-label="Toggle theme"
                className="navigation-theme-btn"
              >
                <span className="navigation-icon-light">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="4"></circle>
                      <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
                    </g>
                  </svg>
                </span>
                <span className="navigation-icon-dark">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"
                    ></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
[data-theme="dark"] .navigation-wrapper {
  background: color-mix(in srgb, var(--color-surface) 80%, transparent);
}
[data-theme="light"] .navigation-wrapper {
  background: color-mix(in srgb, var(--color-surface) 90%, transparent);
}
[data-theme="dark"] .navigation-icon-light {
  display: none;
}
[data-theme="light"] .navigation-icon-dark {
  display: none;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<script defer data-name="navigation-controls">
(function(){
  const mobileOpenBtn = document.getElementById("mobileMenuOpen")
  const mobileCloseBtn = document.getElementById("mobileMenuClose")
  const mobileOverlay = document.getElementById("mobileOverlay")
  const mobileLinks = document.querySelectorAll(".navigation-mobile-link")

  const openMobileMenu = () => {
    mobileOverlay.classList.add("is-open")
    document.body.style.overflow = "hidden"
    mobileOpenBtn.setAttribute("aria-expanded", "true")
  }

  const closeMobileMenu = () => {
    mobileOverlay.classList.remove("is-open")
    document.body.style.overflow = ""
    mobileOpenBtn.setAttribute("aria-expanded", "false")
  }

  mobileOpenBtn.addEventListener("click", openMobileMenu)
  mobileCloseBtn.addEventListener("click", closeMobileMenu)

  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMobileMenu)
  })

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-open")) {
      closeMobileMenu()
    }
  })

  const navWrapper = document.querySelector(".navigation-wrapper")
  window.addEventListener("scroll", () => {
    if (window.scrollY > 20) {
      navWrapper.style.padding = "4px 0"
      navWrapper.style.boxShadow = "0 10px 30px -10px color-mix(in srgb, var(--color-primary) 15%, transparent)"
    } else {
      navWrapper.style.padding = "0"
      navWrapper.style.boxShadow = "none"
    }
  })

  const themeToggle = document.getElementById("themeToggle")
  const html = document.documentElement

  // Initialize theme from localStorage or system preference
  const storedTheme = localStorage.getItem("theme") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")

  applyTheme(storedTheme)

  function applyTheme(theme) {
    const suffix = theme === "dark" ? "dark" : "light"

    // Update ALL active color variables to point to the correct theme
    html.style.setProperty("--color-primary", \`var(--color-primary-\${suffix})\`)
    html.style.setProperty("--color-secondary", \`var(--color-secondary-\${suffix})\`)
    html.style.setProperty("--color-accent", \`var(--color-accent-\${suffix})\`)
    html.style.setProperty("--color-neutral", \`var(--color-neutral-\${suffix})\`)
    html.style.setProperty("--color-surface", \`var(--color-surface-\${suffix})\`)
    html.style.setProperty("--color-on-surface", \`var(--color-on-surface-\${suffix})\`)
    html.style.setProperty("--color-on-surface-secondary", \`var(--color-on-surface-secondary-\${suffix})\`)
    html.style.setProperty("--color-on-primary", \`var(--color-on-primary-\${suffix})\`)
    html.style.setProperty("--color-surface-elevated", \`var(--color-surface-elevated-\${suffix})\`)
    html.style.setProperty("--color-on-secondary", \`var(--color-on-secondary-\${suffix})\`)
    html.style.setProperty("--color-on-accent", \`var(--color-on-accent-\${suffix})\`)
    html.style.setProperty("--color-border", \`var(--color-border-\${suffix})\`)
    html.style.setProperty("--color-outline", \`var(--color-outline-\${suffix})\`)
    html.style.setProperty("--color-overlay", \`var(--color-overlay-\${suffix})\`)
    html.style.setProperty("--color-backplate", \`var(--color-backplate-\${suffix})\`)
    html.style.setProperty("--color-scrim", \`var(--color-scrim-\${suffix})\`)

    html.setAttribute("data-theme", theme)
    localStorage.setItem("theme", theme)
  }

  function toggleTheme() {
    const currentTheme = html.getAttribute("data-theme")
    const newTheme = currentTheme === "light" ? "dark" : "light"
    applyTheme(newTheme)
  }

  if (themeToggle) {
    themeToggle.addEventListener("click", toggleTheme)
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Navigation.defaultProps = {
  text: undefined,
}

Navigation.propTypes = {
  text: PropTypes.element,
}

export default Navigation
